import { StateCreator } from 'zustand';
import { AclDataSlice } from './createAclDataSlice';
import { AclUiSlice } from './createAclUiSlice';

export interface AclModalSlice {
  isModalOpen: boolean;
  isCopyModalOpen: boolean;
  copyRowKeys: number[];

  setIsModalOpen: (value: boolean) => void;
  setIsCopyModalOpen: (value: boolean) => void;
  setCopyRowKeys: (keys: number[]) => void;
}

export const ACL_MODAL_INITIAL_STATE: Pick<AclModalSlice, 'isModalOpen' | 'isCopyModalOpen' | 'copyRowKeys'> = {
  isModalOpen: false,
  isCopyModalOpen: false,
  copyRowKeys: [],
};

export const createAclModalSlice: StateCreator<
  AclDataSlice & AclUiSlice & AclModalSlice,
  [],
  [],
  AclModalSlice
> = (set) => ({
  ...ACL_MODAL_INITIAL_STATE,

  setIsModalOpen: (value) => set({ isModalOpen: value }),
  setIsCopyModalOpen: (value) => set({ isCopyModalOpen: value }),
  setCopyRowKeys: (keys) => set({ copyRowKeys: keys }),
});
